import React from 'react';

export interface IconPowerProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconPower: React.FC<IconPowerProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M12.75 2V1.25H11.25V2V10V10.75H12.75V10V2ZM6.67961 5.57118L7.25079 5.08512L6.27867 3.94276L5.70749 4.42882C4.18094 5.72787 3.08814 7.46753 2.57601 9.4118C2.06389 11.356 2.15689 13.4118 2.84254 15.3012C3.52821 17.1906 4.77377 18.823 6.41159 19.9769C8.04949 21.1307 10.0003 21.75 12 21.75C13.9997 21.75 15.9505 21.1307 17.5884 19.9769C19.2262 18.823 20.4718 17.1906 21.1575 15.3012C21.8431 13.4118 21.9361 11.356 21.424 9.4118C20.9119 7.46753 19.8191 5.72787 18.2925 4.42882L17.7213 3.94276L16.7492 5.08512L17.3204 5.57118C18.6126 6.67077 19.5391 8.14468 19.9735 9.79387C20.4079 11.4431 20.3289 13.1871 19.7474 14.7895C19.166 16.3918 18.1103 17.7743 16.7245 18.7506C15.3388 19.7269 13.6895 20.25 12 20.25C10.3105 20.25 8.66122 19.7269 7.27548 18.7506C5.88965 17.7743 4.83404 16.3918 4.25256 14.7895C3.67106 13.1871 3.59211 11.4431 4.02653 9.79387C4.46094 8.14468 5.38745 6.67077 6.67961 5.57118Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconPower;
